import { Reducer } from "redux";
import { IResult } from "../../data/data";
import { ItemsAction, ItemsActionType } from "../actions";

export const ItemsReducer: Reducer<IResult[]> = (state: IResult[] = [], action: ItemsAction) => {
    switch (action.type) {
        case ItemsActionType.SELECT:
            if (action.id && action.id >= 0) {
                return state.map((item, index) => (
                    {
                        ...item,
                        selected: index === action.id ? !item.selected : item.selected
                    }));
            }
            return state;
        case ItemsActionType.LIKE:
            if (action.id && action.id >= 0) {
                return state.map((item, index) => (
                    {
                        ...item,
                        liked: index === action.id ? !item.liked : item.liked
                    }));
            }
            return state;
        case ItemsActionType.UPDATE:
            if (action.items) {
                return action.items
            }
            return state;
        default:
            return state;
    }
}